import { MessageSquareIcon } from 'lucide-react'

import { UpgradeButton } from '@/modules/auth'

export const TrialChatUsedUpNote = () => (
  <div
    role="note"
    className="flex flex-wrap items-center gap-3 rounded-lg border bg-card px-4 py-3"
  >
    <MessageSquareIcon className="text-brand size-4 shrink-0" aria-hidden />
    <p className="flex-1 text-sm">
      <strong className="font-semibold">
        You have used all the chat included in your trial.
      </strong>{' '}
      Upgrade to keep asking questions about this case.
    </p>
    <UpgradeButton size="sm" />
  </div>
)
